<template>
    <FormGroup
        :name="name"
        :label="label"
        :as-row="asRow"
        :size="size"
        :required="required"
        :errors="errors"
        :hide-validation="!showValidation">
        <template #default>
            <MultiSelectInput v-model="model" :group-by="groupBy" :options="options" />
        </template>

        <template #tips>
            <slot />
        </template>
    </FormGroup>
</template>

<script>
import FieldMixin from '@/js/mixins/FieldMixin';

import FormGroup from '@/js/components/common/fields/FormGroup';
import MultiSelectInput from '@/js/components/common/inputs/MultiSelectInput';

export default {
    name: 'MultiselectField',

    components: {MultiSelectInput, FormGroup},

    mixins: [FieldMixin],

    inheritAttrs: false,

    props: {
        value: {type: Array, default: () => []},
        options: {type: Array, required: true},
        groupBy: {type: String, default: null},
    },

    methods: {
        parse(values) {
            return values.map((item) => String(item.id));
        },

        format(values) {
            return (values || [])
                .map((item) => String(item))
                .map((item) => this.options.find(({id}) => item === String(id)))
                .filter(Boolean);
        },

        validate(values) {
            const errors = [];

            if (this.required && (!values || values.length === 0)) {
                errors.push(this.$t('validation.custom.required'));
            }

            this.modelErrors = errors;
        },
    },
};
</script>
